import useTranslation from 'hooks/useTranslation'
import Skeleton from 'react-loading-skeleton'

const CompaniesElement = ({ showNip = true, data, selected, selectData, edit }) => {
  const { nip = '', name = '', streetName = '', homeNr = '', flatNr = '', postalCode = '', cityName = '', voivodshipName = '' } = data || {}
  const { t } = useTranslation('form')

  return (
    <div
      className={`companies__element list__element --big ${selected ? '--selected' : ''}`}
      onClick={() => data && selectData(data)}>

      {data ? <div className='list__title group'>
        <div>
          <span>{name}</span>
          <span>{showNip && nip ? ` NIP: ${nip}` : ''}</span>
        </div>
        {selected !== undefined && <div className='checkCircle'><i className='icon icon--check'></i></div>}
      </div> : <Skeleton className='skeleton__p' />}

      <div className='group'>
        {data ? <div className='element__text'>
          <div>{streetName} {homeNr}{flatNr ? `/${flatNr}` : ''}</div>
          <div>{postalCode} {cityName}</div>
          <div>{voivodshipName}</div>
        </div> : <Skeleton
          containerClassName='skeleton__text'
          count={3} />}

        {data ? <>
          {selected === undefined && <p className='element__edit'>{t('select')}</p>}
          {edit && <p
            className='element__edit'
            onClick={e => {
              e.stopPropagation()
              edit()
            }}>{t('edit')}</p>}
        </> : <Skeleton
          className='skeleton__icon'
          circle />}
      </div>
    </div>
  )
}

export default CompaniesElement